<template>
  <td :class="classes" :align="align" :colspan="colspan">
    <template v-if="column.type == 'empty'">
      <span></span>
    </template>
    <template v-else-if="column.slot">
      <tg-table-slot :column="column" :row="row"></tg-table-slot>
    </template>
    <template v-else>
      <span>{{ columnValue }}</span>
    </template>
  </td>
</template>

<script>
import TgTableSlot from "./render";
import formatter from "@/utils/formatter";

export default {
  components: {
    TgTableSlot,
  },
  props: {
    column: Object,
    row: Object,
    autoFormat: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  computed: {
    classes() {
      return ["cell"];
    },
    align() {
      return this.column.align || "center";
    },
    columnValue() {
      if (!this.row) {
        return "";
      }
      const value = this.row[this.column.name];

      if (this.autoFormat && this.column.format) {
        return formatter.format(value, this.column.format);
      }

      return value;
    },
    colspan() {
      if (this.column.valuespan) {
        return this.column.valuespan;
      }
      return "";
    },
  },
};
</script>
